import React from 'react';
import { num } from '../logistics/format';
import { DataTable } from './DataTable';

const COLS = [
  { key: 'produto', label: 'Produto', wrap: true },
  { key: 'views_7d', label: 'Visualizações (7 dias)', num: true, fmt: num },
];
const SoughtCard = (r) => (
  <>
    <p className="font-medium">{r.produto}</p>
    <p className="flex justify-between gap-3 text-xs"><span className="text-muted-foreground">Visualizações (7 dias)</span><span className="font-mono">{num(r.views_7d)}</span></p>
  </>
);

export const StockSection = ({ s, isPortal }) => (
  <DataTable columns={COLS} rows={s.out_of_stock_sought} testId="sought-table" empty="Nenhum produto sem estoque com visitas na última semana."
    csvName="sem-estoque-procurados.csv" csvLabel="Exportar CSV" card={isPortal ? SoughtCard : undefined} />
);
